import React from 'react';
import clsx from 'clsx';
import {Avatar, Card, CardContent, Grid, Typography} from '@mui/material';
import useStyles from './styles';
import {Link} from 'react-router-dom';
import PeopleIcon from '@mui/icons-material/PeopleOutlined';

const UsersMetrics = props => {
  const {className, userData, ...rest} = props;
  const classes = useStyles();
  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      {userData &&
      <CardContent>
        <Grid
          container
          justifyContent="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="textPrimary"
              gutterBottom
              variant="body2"
            >
              TOTAL USERS
            </Typography>
            <Typography
              className={classes.valueText}
              variant="h3"
            >{userData.totalUsersCount}</Typography>
          </Grid>
          <Grid item>
            <Link to={'/users'}>
              <Avatar className={classes.avatar}>
                <PeopleIcon className={classes.icon}/>
              </Avatar>
            </Link>
          </Grid>
        </Grid>
      </CardContent>
      }
    </Card>
  );
};

export default UsersMetrics;
